export function checked(value: any, showNull: boolean) {
    if (value === null && showNull) {
        return "";
    }

    if (typeof value !== "boolean") {
        return value;
    }

    return value ? "☑" : "☒";
}

export function YesOrNo(value: any, showNull: boolean) {
    if (value === null && showNull) {
        return "";
    }

    if (typeof value !== "boolean") {
        return value;
    }
    
    return value ? "Yes" : "No";
}


export function boolOptions(value: any, showNull: boolean, trueValue: string, falseValue: string) {
    if (value === null && showNull) {
        return "";
    }

    if (typeof value !== "boolean") {
        return value;
    }
    
    return value ? trueValue : falseValue;
}
